module.exports = __webpack_public_path__ + "static/media/Ｖ_001.4f22e37a.jpg";